import React, { useState } from 'react';
import { Container, FloatingLabel, Form, InputGroup } from 'react-bootstrap';
import { AiOutlineMail, AiOutlineUnlock, AiOutlineUser } from 'react-icons/ai';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';
import { useEffect } from 'react';
import Loader from '../common/Loader';
import { clearErrors, getProductDetails, updateProduct } from '../../redux/actions/productAction';
import MetaData from '../MetaData';
import { Row, Col } from 'react-bootstrap';
import Sidebar from './Sidebar';
import Select from 'react-select';
import categoryList from '../../constants/category.json';
import { UPDATE_PRODUCT_RESET } from '../../redux/constants/productConstants';

const UpdateProduct = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const id = useParams().id;

    const categoryOptions = categoryList.map((data) => {
        return {
            value: data,
            label: data,
        };
    });
    const { product, error } = useSelector((state) => state.productDetails);
    const { loading, isUpdated, error: updateError } = useSelector((state) => state.product);
    const [productDetails, setProductDetails] = useState({
        name: '',
        price: 0,
        description: '',
        Stock: 0,
    });
    const [category, setCategory] = useState(categoryOptions[0]);
    const [productImages, setProductImages] = useState([]);
    const [oldImages, setOldImages] = useState([]);

    useEffect(() => {
        if (!product || product._id !== id) {
            dispatch(getProductDetails(id));
        } else {
            setProductDetails({
                name: product.name,
                price: product.price,
                description: product.description,
                Stock: product.Stock,
            });
            setCategory({
                label: product.category,
                value: product.category,
            });
            setOldImages(product.images);
        }

        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }

        if (updateError) {
            toast.error(updateError);
            dispatch(clearErrors());
        }

        if (isUpdated) {
            toast.success('Product updated successfully');
            navigate('/admin/products');
            dispatch({ type: UPDATE_PRODUCT_RESET });
        }
    }, [error, dispatch, product, isUpdated, id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(
            updateProduct(id, {
                ...productDetails,
                category: category.label,
                images: productImages,
            })
        );
    };

    const handleInputChange = (e) => {
        setProductDetails({ ...productDetails, [e.target.name]: e.target.value });
    };

    const createProductImagesChange = (e) => {
        const files = Array.from(e.target.files);

        setProductImages([]);
        setOldImages([]);

        files.forEach((file) => {
            const reader = new FileReader();

            reader.onload = (e) => {
                if (reader.readyState === 2) {
                    setProductImages((old) => [...old, reader.result]);
                }
            };

            reader.readAsDataURL(file);
        });
    };

    return loading ? (
        <Loader />
    ) : (
        <>
            <MetaData title={'Update Product'} />
            <Container>
                <div className='myOrdersPage section-padding-top section-padding-bottom'>
                    <Row>
                        <Col md={3}>
                            <Sidebar />
                        </Col>
                        <Col md={9}>
                            <form onSubmit={handleSubmit} className='createProductForm'>
                                <h4 className='text-center mb-4'>Create Product</h4>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text id='basic-addon1'>
                                        <AiOutlineUser />
                                    </InputGroup.Text>
                                    <Form.Control
                                        placeholder='Name'
                                        aria-label='Name'
                                        name='name'
                                        type='text'
                                        value={productDetails.name}
                                        onChange={handleInputChange}
                                    />
                                </InputGroup>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text id='basic-addon1'>
                                        <AiOutlineMail />
                                    </InputGroup.Text>
                                    <Form.Control
                                        placeholder='Price'
                                        aria-label='Price'
                                        name='price'
                                        type='number'
                                        min={0}
                                        value={productDetails.price}
                                        onChange={handleInputChange}
                                    />
                                </InputGroup>
                                <FloatingLabel
                                    controlId='floatingTextarea2'
                                    label='Description'
                                    className='mb-3'
                                >
                                    <Form.Control
                                        as='textarea'
                                        name='description'
                                        placeholder='Product Description'
                                        style={{ height: '100px' }}
                                        value={productDetails.description}
                                        onChange={handleInputChange}
                                    />
                                </FloatingLabel>
                                <InputGroup className='select-group mb-3'>
                                    <InputGroup.Text id='basic-addon1'>
                                        <AiOutlineUser />
                                    </InputGroup.Text>
                                    <Select
                                        className='custom-select'
                                        value={category}
                                        onChange={(e) => setCategory(e)}
                                        options={categoryOptions}
                                    />
                                </InputGroup>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text id='basic-addon1'>
                                        <AiOutlineMail />
                                    </InputGroup.Text>
                                    <Form.Control
                                        placeholder='Stock'
                                        aria-label='Stock'
                                        name='Stock'
                                        type='number'
                                        min={1}
                                        value={productDetails.Stock}
                                        onChange={handleInputChange}
                                    />
                                </InputGroup>
                                <div className='my-3'>
                                    <div className='registerImg'>
                                        <input
                                            type='file'
                                            accept='image/'
                                            multiple
                                            onChange={createProductImagesChange}
                                        />
                                    </div>
                                    <div className='d-flex justify-content-center mt-3'>
                                        {oldImages &&
                                            oldImages.map((image, i) => (
                                                <div key={i} className='product-img-preview'>
                                                    <img src={image.url} alt='Product' />
                                                </div>
                                            ))}
                                        {productImages.map((image, i) => (
                                            <div key={i} className='product-img-preview'>
                                                <img src={image} alt='Product' />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <input
                                    type='submit'
                                    value='Create'
                                    className='submitBtn'
                                    disabled={loading ? true : false}
                                />
                            </form>
                        </Col>
                    </Row>
                </div>
            </Container>
        </>
    );
};

export default UpdateProduct;
